import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from "../views/Login";
import Layout from "@/views/Layout";
import UserList from "@/views/admin/UserList";
import AppList from "@/views/app/appList/AppList";
import AppAuthorityList from "@/views/app/AppAuthorityList";
import store from "@/store/index"
import ReleaseList from "@/views/app/ReleaseList";
import CreateRelease from "@/views/app/createRelease/CreateRelease";
import {findUserAccount} from "@/api/login";
import Logout from "@/views/Logout";

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/logout',
    name: 'logout',
    component: Logout
  },
  {
    path: '/app',
    name: 'app',
    component: Layout,
    children: [
      {path: 'apps', name: 'manage apps', component: AppList},
      {path: 'appAuthorities', name: 'manage app appAuthorities', component: AppAuthorityList},
      {path: 'releases', name: "manage app release", component: ReleaseList},
      {path: 'release', name: 'create app release', component: CreateRelease}
    ]
  },
  {
    path: '/admin',
    component: Layout,
    children: [
      {path: 'users', name: 'manage users', component: UserList}
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  // 白名单
  if (to.path === '/login') {
    return next()
  }
  if (!store.state.hasLogin) {
    let user = await findUserAccount()
    if (user === false) {
      return next('/login')
    }
    store.commit("login", user.data)
    if (store.state.user.isAdmin) {
      router.addRoute({path: "/", redirect: "/admin/users"})
      next({ ...to, replace: true })
    } else {
      router.addRoute({path: "/", redirect: "/app/apps"})
      next({ ...to, replace: true })
    }
  }
  next()
})


export default router
